import { render, staticRenderFns } from "./Editarterapia.vue?vue&type=template&id=4e84de7d"
import script from "./Editarterapia.vue?vue&type=script&lang=js"
export * from "./Editarterapia.vue?vue&type=script&lang=js"
import style0 from "./Editarterapia.vue?vue&type=style&index=0&id=4e84de7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports